// store.js
import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "./features/dashboardSlice"; // Adjust path as needed
import documentsReducer from "./features/documentSlice"; // Adjust path as needed
import emailsReducer from "./features/emailsSlice"; // Adjust path as needed
import shipmentsReducer from "./features/shipmentsSlice"; // Adjust path as needed
import caseLogsReducer from "./features/caseLogsSlice";
import authReducer from "./features/LoginSlice";
import profileReducer from "./features/profileSlice";

const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    documents: documentsReducer,
    emails: emailsReducer,
    shipments: shipmentsReducer,
    caseLogs: caseLogsReducer,
    auth: authReducer,
    profile: profileReducer,
  },
});

export default store;
